import store from '~/store'

/**
 * Use only on form.vue part of module
 */
export default async (to, from, next) => {
  let userPermissions = await store.getters['permission/userPermissionsAndActionTasks']
  let componentIndex = await to.matched.findIndex((item, index) => {
    if (item.name === to.name) {
      return index
    }
  })

  /* I know It's fucking spaghetti code, but I really don't know how to realize this
   * On the first call, this data is Promise Func, but later it's just a variable
   */
  let component = (componentIndex > 0)
    ? (await to.matched[componentIndex].parent.components.default instanceof Function)
      ? await to.matched[componentIndex].parent.components.default()
      : await to.matched[componentIndex].parent.components.default
    : (await to.matched[componentIndex].components.default instanceof Function)
      ? await to.matched[componentIndex].components.default()
      : await to.matched[componentIndex].components.default

  if (await checkModuleEditActionLevel(userPermissions, component.metaInfo().title)) {
    return next()
  } else {
    return next({ name: 'permission-alert' })
  }
}

async function checkModuleEditActionLevel (permissions, moduleName) {
  let permissionName
  let moduleAction
  for (let permission of permissions) {
    permissionName = permission.app_permission.visible_name
    moduleAction = permission.app_action_task.name
    if (Array.isArray(moduleName.match(permissionName)) === true &&
      (moduleAction === 'edit' || moduleAction === 'admin')) {
      return true
    }
  }
  return false
}



// WEBPACK FOOTER //
// ./resources/assets/js/middleware/check-action-view-level.js